module.exports = __webpack_public_path__ + "static/media/villager.057b9e77.png";